import React from 'react';
import { useLinesContext } from '../../../../contexts';
import { ILine as Line } from '../../../../global';
import { lineStatus } from '../../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  mobileEditLineButton: { width: '100%' },
}));

interface Props {
  line: Line;
}

export default function MobileEditLineButton({ line }: Props) {
  const classes = useStyles();
  const { editLineClick } = useLinesContext();

  const showButton = !line?.edit && line?.status === lineStatus.draft;

  return (
    <>
      {showButton && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => editLineClick(line)}
          className={classes.mobileEditLineButton}
        >
          Edit Line
        </Button>
      )}
    </>
  );
}
